<template>
    <QuoteCalculator
        v-if="loaded"
        :selected-rate-table="selectedRateTable"
        :zip-code-rates="zipCodeRates"
        :rate-table-options="rateTableOptions"
        :show-rate-table-selector="hasCompanyRole"
        @selectedRateTable="fetchNewZipcodeRates"
        @close="$emit('close')"
    />
</template>

<script>
import { mapActions } from "vuex";
import vuexstore from "./_store";
import QuoteCalculator from "./_components/QuoteCalculator";
import { store, getters } from "src/global-store.js";

export default {
    name: "QuoteCalculatorModule",
    components: {
        QuoteCalculator,
    },
    data() {
        return {
            loaded: false,
            zipCodeRates: [],
            rateTableOptions: [],
            selectedRateTable: "",
        };
    },
    computed: {
        me() {
            return store.me;
        },
        hasCompanyRole() {
            return getters.hasCompanyRole();
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_quoteCalculator", vuexstore);
    },
    destroyed() {
        this.$store.unregisterModule("$_quoteCalculator");
    },
    async created() {
        this.selectedRateTable = this.me.customer_rate_table;
        if (!this.selectedRateTable) {
            this.selectedRateTable = await this.fetchDefaultRateTable();
        }
        this.zipCodeRates = await this.fetchZipCodeRates(
            this.selectedRateTable,
        );

        if (this.hasCompanyRole) {
            this.rateTableOptions = await this.fetchRateTables();
        }
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_quoteCalculator", [
            "fetchZipCodeRates",
            "fetchRateTables",
            "fetchDefaultRateTable",
        ]),
        async fetchNewZipcodeRates(rateTable) {
            this.selectedRateTable = rateTable;
            this.zipCodeRates = await this.fetchZipCodeRates(rateTable);
        },
    },
};
</script>
